import React, { Fragment } from 'react';
import { LeftMenuUser } from '../LeftMenuUser';
import { CurrentUserLimits } from '../../../../slices/current-user/current-user.state';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { VenueId } from '../../../../venues/venues.types';
import { FeatureFlag } from '../../../../containers/FeatureFlags/FeatureFlag';
import { FeatureFlagsEnum } from '../../../../containers/FeatureFlags/FeatureFlags.enum';
import { HomeMenuItem } from '../items/HomeMenuItem';
import { MyAccountMenuItem } from '../items/MyAccountMenuItem';
import { NotificationSettingsMenuItem } from '../items/NotificationSettingsMenuItem';
import { MyDealsMenuItem } from '../items/MyDealsMenuItem';
import { ObservingDealsMenuItem } from '../items/ObservingDealsMenuItem';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';
import { isVisibleInVenue } from '../../../../slices/venue/venue-menu-filter';

const HEADING = 'app-sidebar__heading vertical-nav-menu';

export interface BrokerMenuProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const BrokerMenu = (props: BrokerMenuProps) => {
    const { user } = props;
    const selectedVenue = useSelectedVenueId();
    const engagements = user.engagements || [];

    return (
        <Fragment>
            <div id="left-menu" />
            <div>
                <HomeMenuItem className={HEADING} />
                <MyAccountMenuItem />
                <FeatureFlag flag={FeatureFlagsEnum.FF_Notifications}>
                    <NotificationSettingsMenuItem />
                </FeatureFlag>
            </div>

            {isVisibleInVenue([VenueId.Connect], selectedVenue) &&
                engagements.some(
                    (e: any) => e.party === TimelineParty.Broker
                ) && <MyDealsMenuItem engagements={engagements} />}
            {isVisibleInVenue([VenueId.Connect], selectedVenue) &&
                engagements.some(
                    (e: any) => e.party === TimelineParty.Observer
                ) && <ObservingDealsMenuItem engagements={engagements} />}
        </Fragment>
    );
};
